import { z } from 'zod';
import type { $brand } from 'zod/v4/core';

export type SessionId = string & $brand<'SessionId'>;
export const sessionIdSchema = z.uuid().transform((id) => id as SessionId);

export type SessionNoteId = string & $brand<'SessionNoteId'>;
export const sessionNoteIdSchema = z.uuid().transform((id) => id as SessionNoteId);

// Foreign, declared here rather than imported: same brand, no package edge — the rule the domain
// packages already follow for another context's ids.
export type ClientId = string & $brand<'ClientId'>;
export const clientIdSchema = z.uuid().transform((id) => id as ClientId);

export type PracticeLocationId = string & $brand<'PracticeLocationId'>;
export const practiceLocationIdSchema = z.uuid().transform((id) => id as PracticeLocationId);
